import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Package } from 'lucide-react'
import LoginForm from '../../components/auth/LoginForm'
import useAuthStore from '../../stores/useAuthStore'

/**
 * Login Page
 * User authentication page with branding
 */
const Login = () => {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuthStore()

  // Redirect if already authenticated (on mount only)
  useEffect(() => {
    if (isAuthenticated) {
      console.log('🔵 [Login] Already authenticated, redirecting to /')
      navigate('/', { replace: true })
    }
  }, []) // Empty deps - only run on mount

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-primary-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="flex flex-col items-center justify-center min-h-screen p-4">
        {/* Logo & Branding */}
        <div className="mb-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-primary-600 rounded-2xl mb-4 shadow-lg">
            <Package className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            نظام التوصيل
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            تطبيق المندوبين الميدانيين
          </p>
        </div>

        {/* Login Card */}
        <div className="w-full max-w-md">
          <div className="card p-8 shadow-xl">
            {/* Card Header */}
            <div className="mb-6 text-center">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                مرحباً بك
              </h2>
              <p className="text-gray-600 dark:text-gray-400">
                قم بتسجيل الدخول للمتابعة
              </p>
            </div>

            {/* Login Form */}
            <LoginForm />
          </div>

          {/* Footer Info */}
          <div className="mt-6 text-center">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              نظام إدارة التوصيل والفواتير
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-500 mt-2">
              Built with Alshamel Company
            </p>
          </div>
        </div>

        {/* Version Info */}
        <div className="mt-8 text-center">
          <p className="text-xs text-gray-500 dark:text-gray-500">
            Mobile PWA v1.0.0
          </p>
        </div>
      </div>
    </div>
  )
}

export default Login
